export default __webpack_public_path__ + "static/media/googleUnableConnect.0830772a.svg";